import { combineEpics } from "redux-observable";
import "./views/panel/epics/index.js";
import { messgeCountEpic } from "./views/panel/epics/messageCount.epics.js";
import { messageListEpic } from "./views/panel/epics/messageList.epics.js";
import { dismissMessgeEpic } from "./views/panel/epics/messageDismiss.epics.js";
import { dismissAllMessgeEpic } from "./views/panel/epics/messageDismissAll.epic.js";
import { upsellMessageListEpic } from "./views/panel/epics/upsellMessageList.epics.js";
import { upsellMessageDismissEpic } from "./views/panel/epics/upsellMessageDismiss.epics.js";
import { upsellMessageDismissAllEpic } from "./views/panel/epics/upsellMessageDismissAll.epic.js";
const rootEpic = combineEpics(
  messgeCountEpic,
  messageListEpic,
  dismissMessgeEpic,
  dismissAllMessgeEpic,
  upsellMessageListEpic,
  upsellMessageDismissEpic,
  upsellMessageDismissAllEpic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
